/** Round presentation to minutes; accounting retains precise seconds. */
export const formatGiftDuration = (minutes: number) => {
  const total = Math.max(0, Math.round(Number.isFinite(minutes) ? minutes : 0));
  const hrs = Math.floor(total / 60);
  const mins = total % 60;
  return hrs ? `${hrs} hr${hrs === 1 ? '' : 's'}${mins ? ` con ${mins} min` : ''}` : `${mins} min`;
};
